import React from 'react';
import { Stack, IconButton, Icon } from '@fluentui/react';
import { hideButtonContainerStyle, jitsiShowHideContainerStyle, jitsiShowHideInnerContainerStyle } from '../RoomCallController.style';
import StatusIconBar from '../../comps/Icon/StatusIconBar';
import { useWindowWidth } from 'shared-state/display-options/hooks';

interface IDraggableJitsiContainerProps {
    addOnIsVisible: boolean;
    startingPosition: { bottom: number; left: number };
    translateToHideOrShow: () => { x: number; y: number };
    isSafari: boolean;
    theme: any;
    isVideoHidden: boolean;
    isConnected: boolean;
    encryptionIsEnabled: boolean;
    cameraIsMuted: boolean;
    micIsMuted: boolean;
    jitsiShowHideInnerContainerOpacity: number;
    onDragStartHandler: (e: React.DragEvent<HTMLElement>) => void;
    onDragEndHandler: (e: React.DragEvent<HTMLElement>) => void;
    setIsVideoHidden: (callback: (prev: boolean) => boolean) => void;
    children: React.ReactNode;
}

export const DraggableJitsiContainer: React.FC<IDraggableJitsiContainerProps> = ({
    addOnIsVisible,
    startingPosition,
    translateToHideOrShow,
    isSafari,
    theme,
    isVideoHidden,
    isConnected,
    encryptionIsEnabled,
    cameraIsMuted,
    micIsMuted,
    jitsiShowHideInnerContainerOpacity,
    onDragStartHandler,
    onDragEndHandler,
    setIsVideoHidden,
    children
}) => {
    const { smallDevice, mediumDevice } = useWindowWidth();
    return (
        <Stack
            id={'bottom-left'}
            style={jitsiShowHideContainerStyle({ addOnIsVisible, startingPosition, translateToHideOrShow })}
            horizontal={addOnIsVisible}
            draggable={addOnIsVisible}
            onDragStart={onDragStartHandler}
            onDragEnd={onDragEndHandler}
        >
            <Stack style={jitsiShowHideInnerContainerStyle({ addOnIsVisible })}>
                {addOnIsVisible && !isSafari && (
                    <IconButton
                        styles={{
                            root: { color: theme.palette.white, ':hover': { cursor: 'grab' }, ':active': { cursor: 'grabbing' } }
                        }}
                        style={{ zIndex: 5000 }}
                        iconProps={{ iconName: 'Move' }}
                    />
                )}
                {children}
            </Stack>
            {addOnIsVisible && (
                <Stack style={hideButtonContainerStyle(jitsiShowHideInnerContainerOpacity)} onClick={() => setIsVideoHidden((prev) => !prev)}>
                    <Icon
                        iconName={isVideoHidden ? 'ChevronRightSmall' : 'ChevronLeftSmall'}
                        style={{
                            position: 'absolute',
                            top: '35%',
                            right: '0%',
                            fontSize: '20px',
                            color: theme.palette.white
                        }}
                    />
                </Stack>
            )}
            {!(smallDevice || mediumDevice) && (
                <StatusIconBar connected={isConnected} encryptionEnabled={encryptionIsEnabled} cameraMuted={cameraIsMuted} micMuted={micIsMuted} />
            )}
        </Stack>
    );
};

export default DraggableJitsiContainer;
